const methods = ({ request }) => ({

  getTeamRanksMatchups: ({ year, showStart, showEnd, formulaId }) =>
    request(`Team/RanksMatchups/${year}/${showStart}/${showEnd}/${formulaId}`),

  // /CheatSheets/Auction/10/{season}

  // /CheatSheets/Auction/12/{season}

  // /CheatSheets/Dynasty/{season}

  // /CheatSheets/IDP/{season}/{formula_id}

  // //CheatSheets/Standard/{season}/{formula_id}

  // /Rankings/Preseason/{season}/{position}/{formula_id}

  // /Rankings/Tiers/{season}

  // /Team/Ranks/{season}/{start_week}/{end_week}/{formula_id}
  getTeamPositionRankings: async ({ season, start_week, end_week, formula_id }) =>
    request(`Team/Ranks/${season}/${start_week}/${end_week}/${formula_id}`),

});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/rankings.js